import script from "./AnnouncementBannerContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnouncementBannerContent.vue?vue&type=script&setup=true&lang=ts"

import "./AnnouncementBannerContent.vue?vue&type=style&index=0&id=07a5c172&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a5c172"]])

export default __exports__